import { CommonModule } from '@angular/common';
import { Component, EventEmitter, inject, Output } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import {
  NavigationEnd,
  Router,
  RouterLink,
  RouterModule,
} from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { provideTablerIcons, TablerIconComponent } from 'angular-tabler-icons';
import {
  IconBookmark,
  IconHeadset,
  IconNotebook,
  IconSmartHome,
  IconSparkles,
} from 'angular-tabler-icons/icons';
import { AuthFacadeService } from '../../../../../domain/auth/service/auth-facade.service';
import { TranslateUtil } from '../../../../../shared/util/translate.util';
import { MenuItem } from '../../../../data/MenuItem';

@Component({
  selector: 'app-menu',
  imports: [
    CommonModule,
    RouterLink,
    TablerIconComponent,
    RouterModule,
    TranslateModule,
  ],
  providers: [
    provideTablerIcons({
      IconSmartHome,
      IconHeadset,
      IconNotebook,
      IconSparkles,
      IconBookmark,
    }),
  ],
  templateUrl: './menu.component.html',
  styleUrl: './menu.component.scss',
})
export class MenuComponent {
  @Output() redirected = new EventEmitter<void>();

  private translateUtil = inject(TranslateUtil);

  public items: MenuItem[] = [
    {
      label: this.translateUtil.translate('NAVIGATION.DASHBOARD'),
      icon: 'smart-home',
      routerLink: ['/home'],
    },
    // {
    //   label: this.translateUtil.translate('NAVIGATION.LEARNING_CENTER'),
    //   icon: 'notebook',
    //   routerLink: ['learning-center'],
    // },
    // {
    //   label: this.translateUtil.translate('NAVIGATION.NAVI_AI'),
    //   icon: 'sparkles',
    //   routerLink: ['navi-ai'],
    // },
    // {
    //   label: this.translateUtil.translate('NAVIGATION.RESOURCES_HUB'),
    //   icon: 'bookmark',
    //   routerLink: ['resource-hub'],
    // },
  ];

  constructor(
    private readonly router: Router,
    public readonly authFacadeService: AuthFacadeService
  ) {
    this.router.events.pipe(takeUntilDestroyed()).subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.redirected.emit();
      }
    });
  }
}
